import icon from "../../assets/hammer.svg";
import type { Property } from "../../types";

export const tamperResistance: Property = {
  id: "tamperResistance",
  title: "tamperResistance.title",
  icon,
};
